<template>
  <div>
    <add-cash-form>
    </add-cash-form>
    <cash-modal v-if="showModal && cashing_created_and_waiting_for_payment != null" @close-cash-payment="toggleModal(null)" :cashing="customer_cashing" @close-modal-after-success="toggleModal(null)" ></cash-modal>
    <cash-table @make-cash-payment.capture="toggleModal($event)">
      <filter-bar-cash slot="filter" :user_agencies="user.agencies" :agencies="agencies" :placeholders="placeholders">
      </filter-bar-cash>
    </cash-table>
  </div>
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import AddCashForm from 'components/Cash/AddCashForm'
import FilterBarCash from 'components/Cash/FilterBarCash'
import CashTable from 'components/Cash/CashTable'
import CashModal from 'components/Cash/CashModal'

export default {
    name:"Cash",

    components:{
      FilterBarCash,
      CashTable,
      AddCashForm,
      CashModal,
    },

    data() {
      return {
        placeholders:{
            agency:"Recherche d'une agence",
            customers:"Recherche d'un client",
            payments:"Recherche d'un mode de réglement",
        },
        customer_cashing:null,
        showModal:false,
      }
    },

    methods:{
      ...mapActions('cash', ['set_cashing_waiting_for_payement']),
      ...mapActions(['getUserAgencies']),

      toggleModal(event) {
        if (event != null)
        {
          this.showModal = true
          this.customer_cashing = event
          this.set_cashing_waiting_for_payement(event)
        }
        else
        {
          this.showModal = false
          this.customer_cashing = null
          this.set_cashing_waiting_for_payement(null)
        }
      },

    },

    computed:{
      ...mapState(['user','agencies']),
      ...mapState("cash", ["cashing_created_and_waiting_for_payment"]),
    },

}
</script>



// WEBPACK FOOTER //
// client/views/Cash.vue